import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { OwlDateTimeComponent } from '@danielmoncada/angular-datetime-picker';
import { ModalController } from '@ionic/angular';
import { combineLatest, Observable, Subscription, take } from 'rxjs';
import { Card } from 'src/app/core/models/card/card.model';
import { Permission } from 'src/app/core/models/permissions/permission.model';
import { User } from 'src/app/core/models/user/user.model';
import { ProjectService } from 'src/app/modules/project/services/project.service';
import { ApiRolesService } from 'src/app/modules/roles/services/http/api-roles.service';
import { RolesService } from 'src/app/modules/roles/services/roles.service';
import { CardsService } from 'src/app/modules/users/services/cards.service';
import { ApiUsersService } from 'src/app/modules/users/services/http/api-users.service';
import { LocationGroupsService } from 'src/app/shared/services/location-groups.service';
import { LocationGroup } from '../../services/api-location-groups.service';
import { FiltersService } from 'src/app/shared/services/filters.service';
import { ProjectObject } from 'src/app/core/models/hvac-modes/project-object.model';
import { PermissionType } from 'src/app/core/models/permissions/permission.enum';
import { CardStatus } from 'src/app/core/models/card/card-status.model';
import { CardReaderService } from 'src/app/core/services/card-reader.service';
import { SettingsService } from 'src/app/modules/settings/services/settings.service';
import { Location } from 'src/app/core/models/project/location.model';
import { Setting } from 'src/app/core/models/project/setting.model';
import { AccessRule } from 'src/app/modules/settings/components/access-control-rules/access-control-rules.component';
import { ApiAccessControlRulesService } from 'src/app/modules/settings/services/http/api-access-control-rules.service';

@Component({
  selector: 'app-location-drag-select-modal',
  templateUrl: './location-drag-select-modal.component.html',
  styleUrls: ['./location-drag-select-modal.component.scss']
})
export class LocationDragSelectModalComponent implements OnInit, OnDestroy {

  // @ViewChild('selectContainer') selectContainer: SelectContainerComponent;
  @ViewChild('dtFrom', { static: true }) dtFrom: OwlDateTimeComponent<any>;
  @ViewChild('dtTo', { static: true }) dtTo: OwlDateTimeComponent<any>;
  selectedDateTime: Date[] = [];

  acLocations$ = this.projectService.getAccessControlLocations$();
  floorList$: Observable<LocationGroup[]> = this.locationGroupsService.getFloorList();
  objectsFilterFull$ = this.filtersService.getObjectsFilterFull();

  permissions: Permission[];
  permissionsSubscription: Subscription;

  selectedLocationIds: number[] = [];

  fromDateValid: boolean = false;
  toDateValid: boolean = false;
  showNoRoomsSelectedError = false;

  cardCanBeUsed: boolean;

  openModal = false;
  modalLoading = false;
  userBeingCreated = false;
  allObjects$: Observable<ProjectObject[]> = this.projectService.getObjects();

  selectedRoomDesignation = '*/*/*/*';
  maxDate = this.cardsService.cardsMaxEndDate;

  errorReadingCard = '';
  userFullName: string;

  acRules$ = this.apiAccessControlRulesService.getListOfRulesWithUserIdConditions();
  includedAccessControlRules: number[] = [];

  constructor(private projectService: ProjectService,
              private locationGroupsService: LocationGroupsService,
              private rolesService: RolesService,
              private apiRolesService: ApiRolesService,
              private cardsService: CardsService,
              private apiUserService: ApiUsersService,
              private modalController: ModalController,
              private filtersService: FiltersService,
              private cardReaderService: CardReaderService,
              private settingsService: SettingsService,
              private apiAccessControlRulesService: ApiAccessControlRulesService
              ) { }

  ngOnInit(): void {
    this.selectedDateTime[0] = new Date();
    combineLatest([
              this.settingsService.getDefaultStayDuration(),
              this.settingsService.getDefaultCheckoutTime()
              ])
              .pipe(take(1))
              .subscribe(([ defaultStayDurationDays, defaultCheckoutTime])=> {
                if (defaultStayDurationDays || defaultCheckoutTime) {
                  const departure = new Date();
                  if (defaultCheckoutTime) {
                    departure.setHours(defaultCheckoutTime.hour);
                    departure.setMinutes(defaultCheckoutTime.minute);
                  }
                  if (defaultStayDurationDays) {
                    departure.setDate(departure.getDate() + defaultStayDurationDays);
                  }
                  this.selectedDateTime[1] = departure;
                }
              })

    this.getPermissions();
  }

  getPermissions() {
    this.permissions = this.rolesService.getPermissions();
    this.apiRolesService.getPermissions().subscribe();
    this.permissionsSubscription = this.rolesService.permissionsChanged.subscribe(() => {
      this.permissions = this.rolesService.getPermissions();
    });
  }

  /* ionViewDidEnter	() {
    this.selectContainer.update();// "select container" needs to be updated on each change of its size and position
  }

  onScrollEnd() {
    this.selectContainer.update();
  } */

  dateTimeInput() {
  }

  onCloseFrom() {
    this.selectedDateTime = [this.dtFrom.selecteds[0], this.dtFrom.selecteds[1]];
    this.fromDateValid = false;
  }

  onCloseTo() {
    this.selectedDateTime = [this.dtTo.selecteds[0], this.dtTo.selecteds[1]];
    this.toDateValid = false;
  }

  checkRequiredFields() {
    if (!this.selectedDateTime[0]) {
      this.fromDateValid = true;
    }
    if (!this.selectedDateTime[1] || this.selectedDateTime[1]< new Date()) {
      this.toDateValid = true;
    }
  }

  onModalDecision(decision) {
    this.errorReadingCard = '';
    this.openModal = false;
    this.modalLoading = false;
 }

 onChangeObjectSubobjectRooms(event) {
  this.selectedRoomDesignation = event.target.value;
  // this.selectContainer.clearSelection();
  // this.selectContainer.update();
  }

  clickAccessControlCheckbox(event, clickedLocation: Location , allAcLocations: Location[]) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.cancelBubble = true;
    event.stopPropagation();
      let hardwareGroupAccessControlLocations: Location[];
        // Step 1: Find the AccessControlGroup setting in the clicked location
        const accessControlSetting = clickedLocation.controllers.$values[0].controllerSettings.$values
        .find((setting: Setting) => setting.name === 'AccessControlGroup')
      // Step 2: Check if the value is null
        if (accessControlSetting && accessControlSetting.value != null) {
          const targetValue = accessControlSetting.value;
      // Step 3: Filter acLocs based on the AccessControlGroup setting
      hardwareGroupAccessControlLocations = allAcLocations.filter((loc: Location) => {
          const matchingSetting = loc.controllers.$values[0]
          .controllerSettings.$values.find((setting: Setting) => setting.name === 'AccessControlGroup')
          return matchingSetting && matchingSetting.value === targetValue;
          });
        }
        // location is in hardware group
        if (hardwareGroupAccessControlLocations) {
          if (event.target.checked) {
            const locationsToRemove: number[] = hardwareGroupAccessControlLocations.map(loc => loc.locationId);
            this.selectedLocationIds = this.selectedLocationIds.filter((locId)=> {
              return !locationsToRemove.includes(locId)
            })
          } else  {
            hardwareGroupAccessControlLocations.forEach ( (l: Location) =>  {
                this.selectedLocationIds.push(l.locationId)
            })
          }
        // location not in hardware group
        } else {
          if (event.target.checked) {
            this.selectedLocationIds = this.selectedLocationIds.filter((locId)=> {
              return locId !== clickedLocation.locationId
            })
           }
          else {
              this.selectedLocationIds.push(clickedLocation.locationId)
          }
        }

    }

  async onClickSave() {
    if (!this.selectedDateTime[0] || !this.selectedDateTime[1] || this.selectedDateTime[1]< new Date()) {
      this.checkRequiredFields();
    }

    if (this.selectedLocationIds.length === 0) {
      this.showNoRoomsSelectedError = true;
    }

    if (!this.selectedDateTime[0]
      || !this.selectedDateTime[1]
      || this.selectedLocationIds.length === 0
      || this.selectedDateTime[1]< new Date()) {
      return;
    }

      this.openModal = true;

      let cardReaderInfo: {primaryCardOnReaderInfo?:CardStatus,secondaryCardOnReaderInfo?:CardStatus, error?: string};
      do {
        cardReaderInfo = this.cardReaderService.getDualCardSettings().primaryAntennaOnlyForCommonAreaCards === true ?
        await this.cardReaderService.getCardInfoFromCardReaderForSingleCardTechType()
        :await this.cardReaderService.getCardInfoFromCardReader()
      if (cardReaderInfo.error) {
        this.errorReadingCard = cardReaderInfo.error;
        await new Promise(resolve => setTimeout(resolve,  this.cardReaderService.pauseBetweenCardReadAttemps));
      } else {
        break;
      }
      } while (cardReaderInfo.error && this.openModal)

      if (!cardReaderInfo.primaryCardOnReaderInfo) {
        return;
      }

      this.modalLoading = true;
      this.errorReadingCard = '';

          const user: User = new User();
          user.typeId = 3;
          user.permissions = []
          if (this.userFullName === undefined || this.userFullName === '') {
            user.firstName = 'Guest'
            user.lastName = '';
            user.lastName = Card.getRandomIdForGuestLastName();
          } else {
            const nameSplit = this.userFullName.trim().split(/\s+/); // Split by one or more spaces
            user.firstName = nameSplit[0] || 'Guest';
            user.lastName =  nameSplit.slice(1).join(' ') || Card.getRandomIdForGuestLastName();
            if (user.lastName === undefined || user.lastName === '') {
              user.lastName = Card.getRandomIdForGuestLastName();
            }
          }
          this.permissions.forEach( perm => {
            if(perm.typeId === PermissionType.Unlock && perm?.locationId && this.selectedLocationIds.includes(perm.locationId)) {
              user.permissions.push(perm);
            }
          })

          user.cards = [];
          let card: Card = new Card();
          card.type = 1;

          if (this.cardReaderService.getDualCardSettings().primaryAntennaOnlyForCommonAreaCards === true) {
            card.uid = cardReaderInfo.primaryCardOnReaderInfo.uid;
            card.techTypeId = this.cardReaderService.getDualCardSettings().getPrimaryCardReaderTechTypeId()

            // sub tech types primary card
            card.subTechType = cardReaderInfo.primaryCardOnReaderInfo.typeId;
            card.adriaCard = cardReaderInfo.primaryCardOnReaderInfo.isAdriaCard;

            if (cardReaderInfo.primaryCardOnReaderInfo.isAdriaCard) {
              // if adria card, adriaId overwrites standard uid
              card.uid = cardReaderInfo.primaryCardOnReaderInfo.adriaId;
            }

            card.secondaryUid = null;
            card.secondaryTechTypeId = null;

            card.subTechTypeSecondary = null;
            card.adriaCardSecondary = null;
          }
          else {
            card = Card.setCardUidsAndTechTypes(card, cardReaderInfo, this.cardReaderService.getDualCardSettings());
          }

          card.userId = 0;
          card.validFrom = this.selectedDateTime[0];
          card.validTo = this.selectedDateTime[1];
          card.blacklisted = 0;
          user.cards.push(card);

          this.modalController.dismiss();
          if (!this.userBeingCreated) {
            this.userBeingCreated = true;
            this.openModal = true;
            this.modalLoading = true;
            this.apiUserService.addUser(user).subscribe({
              next :(createdUser) => {

                if (this.includedAccessControlRules.length > 0 ) {
                  const accessRulesForUser = {
                    userId: createdUser.userId,
                    rulesIds: this.includedAccessControlRules
                  }
                  this.apiAccessControlRulesService.updateActiveRulesForUser(accessRulesForUser).subscribe()
                }
                this.userBeingCreated = false;
                this.modalLoading = false;
            }, error: ()=> {
              this.modalLoading = false;
            }});
          }
  }

  clickAccessRuleCheckbox(event: any, rule: AccessRule) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.cancelBubble = true;
    event.stopPropagation();
    if (!this.includedAccessControlRules.includes(rule.id)) {
      this.includedAccessControlRules.push(rule.id)
    } else {
      this.includedAccessControlRules = this.includedAccessControlRules.filter((id)=> {
        return rule.id !== id
      })
    }
  }

  ngOnDestroy() {
    if (this.permissionsSubscription) {
      this.permissionsSubscription.unsubscribe();
    }
  }

}
